import {Grid} from '@mui/material';
import styles from 'assets/jss/AgentStyles/DashboardStyle';
import {digitsEnToFa} from 'persian-tools2';
import {makeStyles} from '@mui/styles';
import {appUrls} from 'helpers/Urls';
import {useEffect, useState} from 'react';
import DotLoading from 'components/Loading/DotLoading';
import {useDashboardData} from "hooks/useDashboardData";

const useStyles = makeStyles(styles);

const DashboardInfo = () => {
    const classes = useStyles();
    const {data: dashboardData, isLoading} = useDashboardData()
    // data
    const data = [
        {label: 'تعداد بیماران مراجعه کرده', value: dashboardData?.patientCount},
        {label: 'تعداد اسکن‌ های انجام شده', value: dashboardData?.scanCount},
        {
            label: 'تعداد تست های دریافت شده',
            value: dashboardData?.scannedRecordsCount,
        },
    ];

    return (
        <Grid container>
            {data.map(({label, value}, index) => (
                <Grid container className={classes.dashboardInfo_container} key={label}>
                    <Grid item xs={9} className={classes.dashboardInfo_RightTitle}>
                        {label} :
                    </Grid>
                    <Grid item xs={3} className={classes.dashboardInfo_LeftTitle}>
                        {isLoading ? (
                            <div
                                style={{
                                    display: 'flex',
                                    justifyContent: 'left',
                                }}>
                                <DotLoading width={30} height={30}/>
                            </div>
                        ) : value || value === 0 ? (
                            digitsEnToFa(value.toString())
                        ) : (
                            '_'
                        )}
                    </Grid>
                </Grid>
            ))}
        </Grid>
    );
};

export default DashboardInfo;
